// src/Sidebar.js
import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './sidebar.css'; // Import the CSS file for styles
import { API_URL, IS_AUTH_REQUIRED } from '../config';
import storage from '../utils/storage';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true); // State to track sidebar visibility
  const location = useLocation(); // Get the current URL path
  const navigate = useNavigate();

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = async () => {
    try {
      const response = await fetch(`${API_URL}/auth/logout/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Logout error', error);
    } finally {
      storage.clearAuthStatus();
      navigate('/login', { replace: true });
    }
  };

  return (
    <div>
      {/* Toggle button for mobile view */}
      <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
        {isOpen ? 'Close' : 'Open'} Sidebar
      </button>

      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <nav className="sidebar-nav">
          <ul>
            {/* Add active class based on the current URL */}
            <li
              className={
                location.pathname === '/' || location.pathname === '/user-list'
                  ? 'active'
                  : ''
              }
            >
              <NavLink to="/user-list" onClick={() => setIsOpen(false)}>
                <i className="fa-solid fa-user"></i> User List
              </NavLink>
            </li>
            <li className={location.pathname === '/template' ? 'active' : ''}>
              <NavLink to="/template" onClick={() => setIsOpen(false)}>
                <i className="fa-solid fa-file-lines"></i> Template
              </NavLink>
            </li>
            <li className={location.pathname === '/domains' ? 'active' : ''}>
              <NavLink to="/domains" onClick={() => setIsOpen(false)}>
                <i className="fa-solid fa-globe"></i> Domains
              </NavLink>
            </li>
          </ul>
        </nav>
        {IS_AUTH_REQUIRED ? (
          <div className="sidebar-footer">
            <button
              type="button"
              className="sidebar-logout-btn"
              onClick={handleLogout}
            >
              <i className="fa-solid fa-arrow-right-from-bracket"></i> Logout
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Sidebar;
